var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useOkapiKy } from '@folio/stripes/core';
import { parseTsl } from '../tsl/core/parser';
import { compileFieldQuery } from './compile';
import { DIAGNOSTIC_MESSAGE_IDS, DIAGNOSTIC_PARAM_DEFAULTS, GENERIC_DIAGNOSTIC_ID, REGISTRY_MESSAGE_IDS, } from './messages';
import { createFieldQueryRegistry } from './registry';
import { createAddressSuggestions } from './suggestions';
import { describeFieldQuery } from './transcript';
import { createValueFetcher } from './values';
/**
 * CZNA-217 — everything the query line needs to understand its text, built once per
 * catalog: the TSL registry with the translated relation words, the compiler, the
 * transcript and the suggestion sources. Undefined until the catalog has loaded.
 */
export var useFieldQueryLanguage = function (catalog, recordTypes) {
    var intl = useIntl();
    var ky = useOkapiKy();
    var format = useCallback(function (id, values) { return intl.formatMessage({ id: id }, values); }, [intl]);
    return useMemo(function () {
        if (!catalog) {
            return undefined;
        }
        var registry = createFieldQueryRegistry({
            catalog: catalog,
            recordTypes: recordTypes,
            translate: function (key) { return (REGISTRY_MESSAGE_IDS[key] ? format(REGISTRY_MESSAGE_IDS[key]) : key); },
        });
        return {
            registry: registry,
            catalog: catalog,
            compileText: function (text, matchCase) { return compileFieldQuery(parseTsl(text, registry), catalog, matchCase); },
            describe: function (compiled) { return describeFieldQuery(compiled, { catalog: catalog, recordTypes: recordTypes, format: format }); },
            formatDiagnostic: function (diagnostic) {
                var _a;
                return format((_a = DIAGNOSTIC_MESSAGE_IDS[diagnostic.messageKey]) !== null && _a !== void 0 ? _a : GENERIC_DIAGNOSTIC_ID, __assign(__assign({}, DIAGNOSTIC_PARAM_DEFAULTS), diagnostic.params));
            },
            fetchValues: createValueFetcher(ky, registry),
            transformSuggestions: createAddressSuggestions(catalog, registry),
        };
    }, [catalog, recordTypes, format, ky]);
};
